import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.isVisible
    ? _c(
        VBtn,
        {
          staticClass: "bg-lpu-branding-color-primary rounded-20",
          attrs: {
            "data-qa": "leave_rate_btn",
            ripple: { class: "bg-lpu-branding-color-primary--text" },
            depressed: "",
            height: "52",
          },
          on: { click: _setup.openNewRateForm },
        },
        [
          _c("div", { staticClass: "bg-gray-0--text" }, [
            _vm._v(
              "\n    " + _vm._s(_setup.tStatic("Оставить отзыв")) + "\n  "
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }